/**
 * FlowProviderSetup - Wires real providers into the FlowProvider
 *
 * This component must be rendered inside BrowserRouter so it can
 * access useNavigate(). It uses useFlowProviders to inject real
 * provider implementations.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlowProviders } from '../providers';
import { RealNavigationProvider } from '../providers/real/RealNavigationProvider';
import { RealUIProvider } from '../providers/real/RealUIProvider';
import { RealAnalyticsProvider } from '../providers/real/RealAnalyticsProvider';
import { RealNotificationProvider } from '../providers/real/RealNotificationProvider';

export const FlowProviderSetup: React.FC = () => {
  const navigate = useNavigate();
  const { setProviders } = useFlowProviders();

  useEffect(() => {
    // Get PostHog instance if available
    const posthog = typeof window !== 'undefined' ? (window as any).posthog : null;

    setProviders({
      navigation: new RealNavigationProvider(navigate),
      ui: new RealUIProvider(),
      analytics: new RealAnalyticsProvider(posthog),
      notifications: new RealNotificationProvider(),
    });
  }, [navigate, setProviders]);

  return null;
};
